import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { SessionService, SitePreferencesDto } from "./api";

export class PreferencesStore extends AlpineComponent {
    constructor(
        private settings : SitePreferencesDto = { showPricesIncludingTax: false },
        public ShowPricesIncludingTax: boolean = settings.showPricesIncludingTax
    ) {
        super();
    }
    
    public async initialize(preferences: SitePreferencesDto) {
        this.settings = preferences;

        window.dispatchEvent(new CustomEvent("preferences-updated", { detail: { preferences: this.settings } }));
    }

    public async SetTaxDisplayPreference(showPricesIncludingTax: boolean) {
        const updatedPreferences: SitePreferencesDto = {
            ...this.settings,
            showPricesIncludingTax: showPricesIncludingTax
        };
        const { data, error } = await SessionService.postUpdatePreferences({
            body: updatedPreferences
        });

        if(!error && data) {
            this.settings = data;
            window.dispatchEvent(new CustomEvent("preferences-updated", { detail: { preferences: this.settings } }));

            return;
        }
        if (error) {
            console.error("Failed to update preferences:", error);
            return;
        }
    }
}